export const INPUTS_DATA = [
  {
    id: "email",
    label: "Email",
    type: "mail",
    maxLength: 100,
    className: "",
  },
  {
    id: "password",
    label: "Mot de Passe",
    type: "password",
    maxLength: 20,
    className: "not",
  },
];

export const NEW_PLAYEUR_INPUTS = [
  {
    id: "name",
    label: "Nom",
    type: "text",
    maxLength: 40,
  },
  {
    id: "firstName",
    label: "Prénom",
    type: "text",
    maxLength: 40,
  },
  {
    id: "birthDay",
    label: "Date de naissance",
    type: "date",
    maxLength: 100,
  },
  {
    id: "phone",
    label: "Numéro de téléphone",
    type: "tel",
    maxLength: 10,
  },
  {
    id: "email",
    label: "Email du joueur",
    type: "email",
  },
 
];
